import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'sc_cookie_notice_dismissed';

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function dismiss() {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-bar">
      <p className="cookie-bar-text">
        This site uses no tracking or advertising cookies. We only use a small localStorage
        entry to remember this notice.{' '}
        <Link to="/privacy" className="cookie-bar-link">Privacy Policy</Link>
      </p>
      <button className="cookie-bar-btn" onClick={dismiss} aria-label="Dismiss cookie notice">
        Got it
      </button>
    </div>
  );
}
